module.exports = __webpack_public_path__ + "img/icon_address.226e37a6.png";